<script>
  import { Form, isDev } from '$client';
  export let isH1 = false;
  export let attributes = {};
  export let data;
  if (isDev() && !data)
    data = {
      header: 'Оцените нашу работу',
      description: '* Поля, обязательные для заполнения',
      button: 'Отправить отзыв',
      fields: [
        {
          id: 1,
          __component: 'fields.rejting',
          placeholder: 'Поставьте оценку',
          required: true,
          description: null,
          key: 'rating',
        },
        {
          id: 7,
          __component: 'fields.tekst',
          placeholder: 'Ваше имя',
          description: null,
          pattern: '^[а-яА-Я ].{4,100}$',
          type: 'small',
          required: true,
          key: 'name',
        },
        {
          id: 4,
          __component: 'fields.telefon',
          required: true,
          description: null,
          key: 'phone',
        },
        {
          id: 3,
          __component: 'fields.pochta',
          placeholder: 'Электронная почта',
          description: null,
          required: false,
          key: 'email',
        },
        {
          id: 2,
          __component: 'fields.vybor',
          placeholder: 'Выберите тему',
          type: 'select',
          description: null,
          required: true,
          key: 'topic',
          options: [
            {
              id: 6,
              header: 'Вывоз КГМ',
            },
            {
              id: 7,
              header: 'Вывоз мебели',
            },
            {
              id: 8,
              header: 'Вывоз вторсырья',
            },
            {
              id: 5,
              header: 'Вывоз техники',
            },
            {
              id: 4,
              header: 'Другое',
            },
          ],
        },
        {
          id: 8,
          __component: 'fields.tekst',
          placeholder: 'Напишите отзыв',
          description: null,
          pattern: '^.{30,250}$',
          type: 'big',
          required: true,
          key: 'text',
        },
      ],
    };
</script>

<section class="container main-form" id="form">
  <div>
    <Form {data} {attributes} {isH1} />
  </div>
</section>

<style lang="scss">
  div {
    &::before {
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      width: 300px;
      height: 300px;
      background-image: url('https://admin.uberi.pro/uploads/review_Form_ef096985bb.webp');
      background-repeat: no-repeat;
      background-size: contain;
      content: '';
    }

    position: relative;
    display: inline-flex;
    gap: 100px;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    padding: 50px;
    padding-right: 300px;
    overflow: hidden;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 6px 20px 0 rgb(0 34 66 / 15%);

    @media only screen and (max-width: 991.98px) {
      flex-direction: column;
      gap: 40px;
      padding-right: 50px;

      &::before {
        width: 250px;
        height: 250px;
      }

      :global(form) {
        width: 100% !important;
      }
    }

    @media only screen and (max-width: 767.98px) {
      gap: 80px;
      padding-block: 30px;

      &::before {
        width: 200px;
        height: 200px;
      }
    }

    @media only screen and (max-width: 570.98px) {
      padding: 15px;

      &::before {
        width: 150px;
        height: 150px;
      }
    }

    @media only screen and (max-width: 450.98px) {
      padding: 10px;

      &::before {
        opacity: 0.4;
      }
    }
  }

  .main-form {
    :global(form) {
      position: relative;
      width: calc(100%);
    }

    :global(form > p) {
      margin-bottom: 30px;
      color: rgb(44 51 60 / 85%);
      font-size: 18px;
      font-family: Roboto;

      @media only screen and (max-width: 767.98px) {
        font-size: 16px;
      }
    }

    :global(form > div) {
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      gap: 15px;

      @media only screen and (min-width: 767.98px) {
        :global(.input-select menu) {
          position: absolute !important;
        }

        :global(> div:first-child) {
          grid-column-start: span 2;
        }

        :global(> div:last-child) {
          grid-column-start: span 2;
        }
      }

      @media only screen and (max-width: 767.98px) {
        grid-template-columns: 1fr;
      }
    }

    :global(form > h2) {
      margin-bottom: 16px;
      font-weight: 800;
      font-family: Vela Sans;

      @media only screen and (max-width: 767.98px) {
        font-size: 24px;
      }
    }

    :global(form > button) {
      padding: 18px 40px;
      background: #22eaac;
      border-radius: 5px;
    }
  }
</style>
